import { Button } from "@/components/ui/button";
import NoDataFallback from "@/components/ui/fallback-nodata";
import ScreenRouteNames from "@/constants/screen-route-names";
import { useMemberService } from "@/hooks/use-member-service";
import useUserInfo from "@/hooks/use-user-info";
import type { ServiceDetail } from "@/model/serviceDetails";
import type Widget from "@/model/widget";
import WidgetCard from "@/pages/components/widget/widget-card";
import { CircleArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Service from "../service/service";
import { useCoverageCertificate } from "@/hooks/use-coverage-certificate";
import { useSelector } from "react-redux";
import type { RootState } from "@/store/store";

type IServicesWidget = {
  widget: Widget;
};

const ServicesWidget: React.FC<IServicesWidget> = ({ widget }) => {
  const { activeCoverage } = useSelector(
    (state: RootState) => state.planCoverageInfo,
  );
  const userInfo = useUserInfo();
  const serviceQuery = useMemberService(userInfo);
  useCoverageCertificate(activeCoverage);
  const navigate = useNavigate();
  const renderWidget = () => {
    return (
      <div className="flex w-full gap-4 overflow-x-scroll">
        {serviceQuery.data &&
        serviceQuery.data?.serviceDetails.filter(
          (service: ServiceDetail) => service.category !== "Document",
        ).length > 0 ? (
          serviceQuery.data?.serviceDetails
            .filter((service) => service.category !== "Document")
            .map((service: ServiceDetail, index: number) => {
              return <Service key={index} {...service} />;
            })
        ) : (
          <NoDataFallback title="Services" />
        )}
      </div>
    );
  };
  const viewAll = () => {
    //like xa view all ko satta
    const targetPath = `/${ScreenRouteNames.SERVICE.path}`;
    navigate(targetPath, {
      replace: false,
    });
  };

  const footerContent = (
    <Button variant="link" className="w-full hover:underline" onClick={viewAll}>
      View All <CircleArrowRight className="ml-1" />
    </Button>
  );

  return (
    <WidgetCard title={widget?.widgetDisplayName} footerContent={footerContent}>
      {renderWidget()}
    </WidgetCard>
  );
};

export default ServicesWidget;
